import React from "react";
import Hero from "@/components/sections/Hero";
import TrustMetrics from "@/components/sections/TrustMetrics";
import TrustBadges from "@/components/sections/TrustBadges";
import ServicesGrid from "@/components/sections/ServicesGrid";
import WhyZopran from "@/components/sections/WhyZopran";
import Ecosystem from "@/components/sections/Ecosystem";
import IndustriesSection from "@/components/sections/IndustriesSection";
import IndiaEurope from "@/components/sections/IndiaEurope";
import ProcessFlow from "@/components/sections/ProcessFlow";
import Testimonials from "@/components/sections/Testimonials";
import CTA from "@/components/sections/CTA";
import LeadForm from "@/components/LeadForm";
import { useT } from "@/lib/i18n";

export default function Home() {
  const { t } = useT();
  return (
    <div data-testid="page-home">
      <Hero />
      <TrustMetrics />
      <TrustBadges />
      <ServicesGrid />
      <WhyZopran />
      <Ecosystem />
      <IndustriesSection />
      <IndiaEurope />
      <ProcessFlow />
      <Testimonials />
      <CTA />

      <section
        id="quote-form"
        data-testid="home-leadform-section"
        className="relative py-24"
      >
        <div className="max-w-5xl mx-auto px-6 sm:px-8">
          <div className="text-center mb-10">
            <div className="zp-label">Quick Quote</div>
            <h2 className="font-display text-3xl sm:text-5xl tracking-tighter mt-3">
              {t("form.title")}
            </h2>
            <p className="text-[color:var(--zp-text-2)] mt-4 max-w-xl mx-auto">
              {t("form.subtitle")}
            </p>
          </div>
          <LeadForm source="home" />
        </div>
      </section>
    </div>
  );
}
